import { IOrganization, OrganizationTier } from '@dadohr/shared/domainTypes/org';
import * as ENVS from '../../env.json';
import { useCurrentUser } from '../currentUser';

export const useIsTier = (tier: OrganizationTier) => {
  const { org } = useCurrentUser();
  return org.tier === tier;
};

export const useIsFreeTier = () => {
  return useIsTier(OrganizationTier.FREE);
};

export const isFreeTierOrg = (d: IOrganization) => {
  return d.tier === OrganizationTier.FREE;
};

export const getFreeTierSampleContentOrgId = () => {
  // will be based on environemtn later
  return ENVS.env.name === 'Production'
    ? 'FREE_TIER_SAMPLE_CONTENT_ORG_PROD'
    : 'FREE_TIER_SAMPLE_CONTENT_ORG_DEV';
};

export const getOrgIdOrFreeTierSampleContentOrgId = (org: IOrganization) => {
  return isFreeTierOrg(org) ? getFreeTierSampleContentOrgId() : org.id;
};
